import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./HomePage.css";

const HomePage = () => {
  const navigate = useNavigate();
  const [showChangelog, setShowChangelog] = useState(true);

  // Sitzung erstellen
  const createSession = async () => {
    try {
      const response = await fetch("https://app.sijelly.com/api/session/start", {
        method: "POST",
      });

      if (!response.ok) {
        throw new Error("Fehler beim Erstellen der Sitzung");
      }

      const data = await response.json();
      localStorage.setItem("sessionId", data.session_id); // Speichere die session_id im LocalStorage
      console.log("Sitzung erstellt:", data.session_id);

      navigate("/all-in-one"); // Weiter zur UnifiedPage navigieren
    } catch (error) {
      console.error("Fehler beim Erstellen der Sitzung:", error);
      alert("Es gab ein Problem beim Starten der Sitzung. Bitte versuchen Sie es erneut.");
    }
  };

  return (
    <div className="home">
         {/* 📌 Changelog Box */}
         {showChangelog && (
          <div className="changelog-box">
            <button className="close-button" onClick={() => setShowChangelog(false)}>❌</button>
            <h3>🆕 Änderungen in Version 1.1.1</h3>
            <ul>
              <li>Versionnummer hinzugefügt</li>
              <li>Änderungs -Notiz integriert</li>
              <li>Alle Funktionen auf einer Seite zusammengeführt</li>
              <li>Keine "weiter" Button mehr</li>
              <li>Bugfixes und Performance-Optimierungen</li>
              <li>Beenden Button hinzugefügt</li>
              <li>Hinweis zum Excel herunterladen Ort festlegen</li>
              <li>Formel wird Automtisch zugeordnet</li>
            </ul>
          </div>
        )}

      <h2>Willkommen zu CSV to UMS</h2>
      <p>Importieren Sie Dateien, analysieren Sie Daten und exportieren Sie Ergebnisse.</p>
      <div className="button-container">
        <button className="home-button" onClick={createSession}>
          <i className="icon-upload"></i> Start
        </button>
      </div>
    </div>
  );
};

export default HomePage;